import SuccesMessage from './SuccesMessage';
export default SuccesMessage;